import React, { useState } from "react";
import "../styles/Transposhelppanel.css";
import { useGame } from "../GameContext";

const Helppanel: React.FC = () => {
  console.log("HelpPanel render");
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="transpos-helpPanel" id="transpos-helpPanel">
      <img
        src="/img/close.svg"
        id="transpos-closeButton"
        alt="Закрыть"
        className="transpos-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="transpos-helpPivots">
        <div
          className="transpos-selectPivots"
          id={showhelpPivots === "pivotTask" ? "transpos-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="transpos-commandsCards">
          <div className="transpos-helpCard">
            <div className="transpos-cardCaption">Суть игры</div>
            <div>
              <div>
                123123!!!!
              </div>
            </div>
          </div>
          <div className="transpos-helpCard">
            <div className="transpos-cardCaption">Правила игры</div>
            <div>
              <div>
                123123123!!!!
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
